//Suites 2 recamara

// Premium Master Suite
import image1 from "../../assets/Suites/Suites 2 Recamaras/PremiumMasterSuite/PremiumMasterSuite-1.webp"
import image2 from "../../assets/Suites/Suites 2 Recamaras/PremiumMasterSuite/PremiumMasterSuite-2.webp"
import image3 from "../../assets/Suites/Suites 2 Recamaras/PremiumMasterSuite/PremiumMasterSuite-3.webp"
import image4 from "../../assets/Suites/Suites 2 Recamaras/PremiumMasterSuite/PremiumMasterSuite-4.webp"
import image5 from "../../assets/Suites/Suites 2 Recamaras/PremiumMasterSuite/PremiumMasterSuite-5.webp"
import image6 from "../../assets/Suites/Suites 2 Recamaras/PremiumMasterSuite/PremiumMasterSuite-6.webp"
import image7 from "../../assets/Suites/Suites 2 Recamaras/PremiumMasterSuite/PremiumMasterSuite-7.webp"
import image8 from "../../assets/Suites/Suites 2 Recamaras/PremiumMasterSuite/PremiumMasterSuite-8.webp"
import image9 from "../../assets/Suites/Suites 2 Recamaras/PremiumMasterSuite/PremiumMasterSuite-9.webp"
import image10 from "../../assets/Suites/Suites 2 Recamaras/PremiumMasterSuite/PremiumMasterSuite-10.webp"

const PremiumMasterSuite = {
    "images":[
        {
        "original":image1,
        "thumbnail":image1
        },
        {
        "original":image2,
        "thumbnail":image2
        },
        {
        "original":image3,
        "thumbnail":image3
        },
        {
        "original":image4,
        "thumbnail":image4
        },
        {
        "original":image5,
        "thumbnail":image5
        },
        {
        "original":image6,
        "thumbnail":image6
        },
        {
        "original":image7,
        "thumbnail":image7
        },
        {
        "original":image8,
        "thumbnail":image8
        },
        {
        "original":image9,
        "thumbnail":image9
        },
        {
        "original":image10,
        "thumbnail":image10
        }
    ] 
}

export default PremiumMasterSuite;